<template>
    <div>
      <div class="hero is-bold">
        <div class="hero-body" style="padding-left: 0px">
          <div class="level" style="width:100%">
            <div class="level-left">
              <v-btn icon @click="$router.replace({ name: 'Clusters' })">
                <v-icon large>keyboard_arrow_left</v-icon>
              </v-btn>
              <h1 class="title">{{cluster.name}}</h1>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button icon-left="edit" class="button is-info level-item" @click="editCluster($route.params.id)">Edit</b-button>
              </div>
              <div class="level-item">
                <b-button :disabled="role !== 'admin' && role !== 'device' && isMigrated" icon-left="trash" class="button is-danger level-item" @click="confirmRemove">Remove</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content is-medium">
        <p><b>Main Playlist:</b> {{cluster.mainPlaylistId ? mainPlaylist.name : 'None'}}</p>
        <!--<p><b>Extended Playlist:</b> {{cluster.extendedPlaylistId || 'None'}}</p>-->
        <p v-if="cluster.menuId.length > 0"><b>Menu:</b> {{clusterMenu.name}}</p>
        <p v-if="cluster.specialOffersMenuId.length > 0"><b>Special Offers Menu:</b> {{clusterSpecialOffer.name}}</p>
        <p><b>Devices:</b></p>
      </div>

      <b-table :data="tableData.length > 0 ? tableData : []" striped>
        <template slot-scope="props">
          <b-table-column field="name" label="Device Name" centered>
            {{props.row.name}}
          </b-table-column>
          <b-table-column field="id" label="MAC Address" centered>
            {{props.row.id}}
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="window-close"
                  size="is-medium">
                </b-icon>
              </p>
              <p>No devices to display.</p>
            </div>
          </section>
        </template>
      </b-table>

      <v-divider></v-divider>
    </div>
</template>

<script>
import ClusterAddEdit from '@/components/clusters/ClusterAddEdit'

export default {
  name: 'ClusterDetails',
  data: () => {
    return {
      tableData: []
    }
  },
  computed: {
    cluster () {
      let id = this.$route.params.id
      return this.$store.getters.getCluster(id)
    },
    mainPlaylist () {
      return this.$store.getters.getPlaylist(this.cluster.mainPlaylistId)
    },
    clusterMenu () {
      return this.$store.getters.getMenu(this.cluster.menuId)
    },
    clusterSpecialOffer () {
      return this.$store.getters.getSpecialOffer(this.cluster.specialOffersMenuId)
    },
    devices () {
      let id = this.$route.params.id
      return this.$store.getters.getDevicesForCluster(id)
    },
    role () {
      return this.$store.state.role
    },
    isMigrated () {
      return !this.getNotMigrated().includes(this.$store.state.uid)
    }
  },
  mounted: function () {
    for (let device in this.devices) {
      this.tableData.push({ id: device, ...this.devices[device] })
    }
  },
  watch: {
    devices (devices) {
      this.tableData = []
      for (let device in this.devices) {
        this.tableData.push({ id: device, ...this.devices[device] })
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'Clusters' })
    },
    editCluster (id) {
      this.$buefy.modal.open({
        parent: this,
        component: ClusterAddEdit,
        props: { editEnabled: true, propId: id },
        hasModalCard: true,
        trapFocus: true
      })
    },
    confirmRemove () {
      this.$buefy.dialog.confirm({
        title: 'Delete cluster',
        message: 'Are you sure you want to <b>delete</b> this cluster? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => this.removeCluster()
      })
    },
    removeCluster () {
      let id = this.$route.params.id
      let associatedDevicesRef = this.$store.getters.getDevicesForCluster(id)
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        for (let device in associatedDevicesRef) {
          this.$store.state.database.ref('/neoslide/devices/' + this.$store.state.workspaceId + '/' + device).update({
            clusterId: ''
          })
        }
      } else {
        for (let device in associatedDevicesRef) {
          this.$store.state.database.ref('/devices/' + this.$store.state.uid + '/' + device).update({
            clusterId: ''
          })
        }
      }
      let removeClusterRef = null
      if (!this.getNotMigrated().includes(this.$store.state.uid)) {
        removeClusterRef = this.$store.state.database.ref('/neoslide/clusters/' + this.$store.state.workspaceId + '/' + id)
      } else {
        removeClusterRef = this.$store.state.database.ref('/clusters/' + this.$store.state.uid + '/' + id)
      }
      removeClusterRef.remove()
      this.$router.push({ name: 'Clusters' })
    },
    getDevicesCount (id) {
      return this.$store.getters.getDevicesCountForCluster(id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/clusters/ClusterDetails.vue